// Australian Standard service/site symbols commonly used on plumbing,
// drainage and utility site plans (AS 1100.401 / AS 3500 conventions).
// Each entry is a short 2–4 letter code + full plain-english label.
export const AS_SYMBOLS = [
  { code: "IO",   label: "Inspection Opening" },
  { code: "IP",   label: "Inspection Point" },
  { code: "BV",   label: "Boundary Vent" },
  { code: "DP",   label: "Down Pipe" },
  { code: "RWT",  label: "Rainwater Tank" },
  { code: "WM",   label: "Water Meter" },
  { code: "GM",   label: "Gas Meter" },
  { code: "EM",   label: "Electric Meter" },
  { code: "GT",   label: "Grease Trap" },
  { code: "STP",  label: "Septic Tank" },
  { code: "PUMP", label: "Pump / Pit Station" },
  { code: "MH",   label: "Manhole / Access Chamber" },
  { code: "HYD",  label: "Fire Hydrant" },
  { code: "RPZ",  label: "Backflow Prevention Valve" },
  { code: "VLV",  label: "Valve" },
  { code: "TB",   label: "Trap / Boundary Trap" },
  { code: "TW",   label: "Tempering Valve" },
  { code: "CO",   label: "Cleanout" },
  { code: "AAV",  label: "Air Admittance Valve" },
  { code: "FW",   label: "Floor Waste" },
  { code: "TMV",  label: "Thermostatic Mixing Valve" },
  { code: "SPS",  label: "Sewer Pump Station" },
];

// Quick lookup for full label from a stamped code.
export const AS_LABEL_BY_CODE = Object.fromEntries(
  AS_SYMBOLS.map((s) => [s.code, s.label])
);

// Suggestion string for prompt-based UX (map pin label hint etc.).
export const AS_HINT_LIST = AS_SYMBOLS.map((s) => s.code).join(" · ");
